//@ts-check
import { useMemo } from 'react';

import useIntegrationDetailsData from '../useIntegrationDetailsData';

/**
 * @description Finds all products that are associated with a service.
 * @param {import('@action-types/user').Product[]} [products]
 * @param {import('@action-types/service').Service} [service]
 */
const findProducts = (products, service) => {
  return products?.filter?.((product) =>
    service?.properties?.licenseConfigs?.some((config) => config?.productId === product?.id)
  );
};

/** @param {import('@action-types/user').LicenseGroup[]} licenseGroups */
const getSortedProfiles = (licenseGroups) => {
  return licenseGroups?.slice().sort((a, b) => a?.name?.localeCompare(b?.name));
};

/**
 * @param {import('@action-types/user').Product[]} products - The array of products.
 * @param {import('@action-types/service').Service[]} services - The array of services.
 */
const getProductProfiles = (products, services) =>
  services
    ?.map((service) => {
      const name = service.name;
      const serviceProducts = findProducts(products, service);
      if (serviceProducts?.length > 0) {
        const profiles = getSortedProfiles(serviceProducts.flatMap((product) => product.licenseGroups));
        const id = service.id;
        return { id, name, profiles };
      }
    })
    .filter(Boolean);

const useProductProfilesTableData = () => {
  const { userQuery, servicesQuery } = useIntegrationDetailsData();
  const services = servicesQuery?.data?.services;
  const products = userQuery?.data?.products;
  const productProfiles = useMemo(() => getProductProfiles(products, services), [products, services]);

  return productProfiles;
};

export default useProductProfilesTableData;
